<app-spinner [loading]="spinnerService.loading$ | async"></app-spinner>
<app-header-bar (routerLinkClick)="routerLinkClicked()" />
<app-primary-card id="client-card" [title]="_pageTitle | translate">
  <form id="client-form" (ngSubmit)="Submit()">
    <app-dropdown
      id="client-type"
      *ngIf="_mode == 'add'"
      label="{{ 'Client Type' | translate }}"
      required="true"
      [control]="_clientForm.controls['clientType']"
      [data]="_clientTypes"
      errorText="{{ 'Client Type is required' | translate }}"
    />

    <app-text-input
      id="first-name"
      *ngIf="_clientForm.controls['clientType'].value == 'standard'"
      label="{{ 'First Name' | translate }}"
      placeholder="{{ 'First Name' | translate }}"
      [control]="_clientForm.controls['firstName']"
    />

    <app-text-input
      id="preferred-name"
      *ngIf="_clientForm.controls['clientType'].value == 'standard'"
      label="{{ 'Preferred Name' | translate }}"
      placeholder="{{ 'Preferred Name' | translate }}"
      [control]="_clientForm.controls['preferredName']"
    />

    <app-text-input
      id="last-name"
      [label]="GetLastNameText() | translate"
      required="true"
      [placeholder]="GetLastNameText() | translate"
      [control]="_clientForm.controls['lastName']"
      [errorText]="GetLastNameErrorText() | translate"
    />

    <app-dropdown
      id="gender"
      label="{{ 'Gender' | translate }}"
      [control]="_clientForm.controls['gender']"
      [data]="_genders"
    />

    <app-datepicker
      id="date-of-birth"
      label="{{ 'Date of Birth' | translate }}"
      required="true"
      placeholder="{{ 'Date of Birth' | translate }} (DD/MM/YYYY)"
      [control]="_clientForm.controls['dateOfBirth']"
      [errorText]="GetDateOfBirthErrorText() | translate"
    />

    <app-searchable-dropdown
      id="case-manager"
      label="{{ 'Case Manager' | translate }}"
      [control]="_clientForm.controls['caseManager']"
      [data]="_caseManagers"
    />

    <app-dropdown
      id="primary-location"
      *ngIf="hasLocations()"
      label="{{ 'Primary Location' | translate }}"
      [control]="_clientForm.controls['primaryLocation']"
      [data]="_locations"
    />

    <app-dropdown
      id="flip-template"
      *ngIf="hasTemplates()"
      label="{{ 'FLI-P Template' | translate }}"
      required="true"
      [control]="_clientForm.controls['flipTemplate']"
      [data]="_flipTemplates"
      errorText="{{ 'FLI-P Template is required' | translate }}"
    />
    <p id="flip-template-message" *ngIf="!hasTemplates()">
      {{ 'No FLI-P templates are available. Please contact HearHub Support.' | translate }}
    </p>

    <p id="primary-location-message" *ngIf="!hasLocations()">
      {{ 'No locations are set up for your organisation. Please contact HearHub support to create locations.' | translate }}
    </p>

    <div id="button-container">
      <app-link-button
        id="cancel-button"
        type="button"
        color="accent"
        (click)="CancelClicked()"
        >{{ 'Cancel' | translate }}</app-link-button
      >
      <app-action-button
        id="submit-button"
        kind="filled"
        color="primary"
        size="standard"
        >{{ 'Submit' | translate }}</app-action-button
      >
    </div>
  </form>
</app-primary-card>
